module.exports = __webpack_public_path__ + "static/media/FrX_l5faUAAhU14.7536ee9f.webp";